import { render } from "./HistoryModal.vue?vue&type=template&id=59accbe9&scoped=true"
import script from "./HistoryModal.vue?vue&type=script&lang=ts"
export * from "./HistoryModal.vue?vue&type=script&lang=ts"

import "./HistoryModal.vue?vue&type=style&index=0&id=59accbe9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-59accbe9"

export default script